import React, { useEffect } from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-1 container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
            Contact Us
          </h1>

          <div className="bg-white rounded-lg shadow-sm p-6">
            <h2 className="text-xl font-semibold mb-6">Get in Touch</h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 text-gray-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium text-gray-900">Email</p>
                  <a 
                    href="mailto:jamie@pacerapp.co.uk" 
                    className="text-gray-600 hover:text-gray-900"
                  >
                    jamie@pacerapp.co.uk
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 text-gray-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium text-gray-900">Phone</p>
                  <a 
                    href="tel:+447368907914" 
                    className="text-gray-600 hover:text-gray-900"
                  >
                    +44 073 6890 7914
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 text-gray-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium text-gray-900">Location</p>
                  <p className="text-gray-600">
                    London<br />
                    United Kingdom
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}